module.exports = __webpack_public_path__ + "media/images/icons/flags/MZ-c63efd62e63180fa38893c81642759d4.svg";